import { PopperContent } from '@/components/poppers/PopperContent';

export function RemainderValue() {
  return (
    <PopperContent
      body={'Represents the remainder value at the end of the GRAT term.'}
    />
  );
}
